var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-file-selection.ts
import { findEntityByText, getByID } from "@adornis/baseql/operations/mongo.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-loader.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import { askForFile } from "@adornis/file-utils/client/helper-methods.js";
import "@adornis/file-utils/db/files.js";
import "@adornis/fonts/fonts.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/popover/x-dropdown-search-selection.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { map, of, switchMap } from "rxjs";
import { BuildifyFile, BuildifyImage } from "../../db/BuildifyFile.js";
var XBuildifyFileSelection = class extends FormField {
  constructor() {
    super(...arguments);
    this.isImage = new RXController(this, false);
    this._fileClass = new RXController(
      this,
      this.isImage.observable.pipe(
        map((isImage) => {
          if (isImage)
            return BuildifyImage;
          return BuildifyFile;
        })
      )
    );
    this._file = new RXController(
      this,
      this.value.observable.pipe(
        switchMap((fileID) => {
          const fileClass = this._fileClass.value;
          if (!fileID || !fileClass)
            return of(null);
          return fileClass.getByID(fileID)(fileClass.allFields);
        })
      )
    );
  }
  render() {
    if (this._file.isLoading)
      return html` <x-loader></x-loader> `;
    const fileClass = this._fileClass.value;
    if (!fileClass)
      return html` file class not found `;
    const file = this._file.value;
    if (file) {
      return html`
        <x-flex space="md">
          <x-text> ${file.meta?.fileName} </x-text>
          <x-button
            icon="upload_file"
            @click=${async () => {
        this._setValue(null);
      }}
          >
            andere Datei auswählen
          </x-button>
        </x-flex>
      `;
    }
    return html`
      <x-flex space="sm">
        <x-button
          icon="upload"
          @click=${async () => {
      const files = await askForFile({
        acceptMultipleFiles: false,
        acceptFileTypes: this.isImage.value ? ".png,.jpeg,.jpg,.svg,.webp" : void 0
      });
      const file2 = files?.[0];
      if (!file2)
        return;
      await XNativeDialog.waitFor(
        new Promise(async (resolve, reject) => {
          try {
            const uploadedFileID = await fileClass.upload(file2);
            const uploadedFile = await getByID(fileClass, uploadedFileID)(fileClass.allFields);
            if (uploadedFile?.meta) {
              uploadedFile.meta.fileName = file2.name;
              await uploadedFile.save();
            }
            this._setValue(uploadedFileID);
            resolve();
          } catch (err) {
            reject(err);
          }
        }),
        "Bild wird hochgeladen..."
      );
    }}
        >
          Datei hochladen
        </x-button>
        <x-dropdown-search-selection
          placeholder=${"Datei ausw\xE4hlen"}
          .search=${async (search) => {
      const files = await findEntityByText(
        fileClass,
        ["meta.fileName"],
        search
      )({ meta: { fileName: 1, extension: 1 } });
      return files;
    }}
          .renderString=${(file2) => {
      if (!file2)
        return "";
      return `${file2.meta?.fileName}.${file2.meta?.extension}`;
    }}
          .renderItem=${(file2) => {
      return html`
              <x-flex padding="xs">
                <x-text ${css({ color: this.value.value === file2._id ? this.colors.accent : "#000" })}>
                  ${file2.meta?.fileName}.${file2.meta?.extension}
                </x-text>
              </x-flex>
            `;
    }}
          @value-picked=${(e) => {
      this._setValue(e.detail.value._id);
    }}
        ></x-dropdown-search-selection>
      </x-flex>
    `;
  }
  _setValue(value) {
    this.value.next(value);
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value } }));
    this.requestUpdate();
  }
};
__decorateClass([
  property({ attribute: "image", type: Boolean })
], XBuildifyFileSelection.prototype, "isImage", 2);
__decorateClass([
  state()
], XBuildifyFileSelection.prototype, "_fileClass", 2);
__decorateClass([
  state()
], XBuildifyFileSelection.prototype, "_file", 2);
XBuildifyFileSelection = __decorateClass([
  customElement("x-buildify-file-selection")
], XBuildifyFileSelection);
export {
  XBuildifyFileSelection
};
